angular.module("khUtils").factory('RegionsFactory', ['$resource', function ($resource) {
    return $resource('/api/v1.0/profiles/regions/');
}]);
